module.exports = __webpack_public_path__ + "img/w24b.4deefefe.jpg";